import clsx from 'clsx'

import Arrow from '@/atoms/Arrow/Arrow'

import { AccordionLabelProps } from './ts/AccordionTypes'

function AccordionLabel({
  heading,
  expanded,
  alwaysOpen,
}: AccordionLabelProps) {
  return (
    <div className="flex items-center justify-between text-violet-200">
      <h3 className="font-medium leading-none">{heading}</h3>
      {!alwaysOpen && (
        <span
          className={clsx(
            'w-3 h-3 text-violet-200 transform transition-transform duration-200',
            {
              '-scale-y-1': expanded,
            }
          )}
        >
          <Arrow />
        </span>
      )}
    </div>
  )
}

export default AccordionLabel
